export default {
	methods: {
		resetFields() {
			for (let field of this.formFields) {
				field.VALUE = '';
			}
		},
		setDefault: function () {
			this.error = false;
			this.success = false;
			this.message = '';
		},
		onConfirmedSuccess: function() {
			if(this.authMode)
			{
				this.goBack();
			}
			else {
				this.success = true;
			}
		},
		isValidate: async function (component) {
			let isValid = true,
				val = null;
			if (!component)
				component = this;

			if (component.$refs.hasOwnProperty('field')) {
				for (let field of component.$refs.field) {
					val = await field.checkValid();
					if (!val) {
						isValid = false;
					}
				}
			}

			if (component.$refs.hasOwnProperty('group')) {
				for (let group of component.$refs.group) {
					let isValidGroup = await this.isValidate(group);
					if (!isValidGroup)
						isValid = false;
				}
			}

			if (component.$refs.hasOwnProperty('checkbox')) {
				val = await this.$validator.validate().then(result => {
					return result;
				}).catch(() => {
					return false;
				});

				if (!val) {
					isValid = false;
				}
			}

			return isValid;
		},
	}
}
